<template>
  <div>
    <b-card no-header>
      <b-form>
        <div class="grupo-controles search-presupuestos-internos">
          <b-form-group
            label="Nro. Presupuesto:"
            label-for="numero"
            :label-cols="labelCols"
            horizontal
            description="Ingrese el número de presupuesto y adicional y haga click en el botón de búsqueda">
            <b-input-group>
              <b-form-input 
                id="numero"
                class="number-input"
                v-model.number="numero" 
                type="number"
                :state="presupuestoInternoValido"
                @focus="$event.target.select()"/>

              <b-input-group-append>
                <b-input-group-text>
                  /
                </b-input-group-text>
              </b-input-group-append>

              <b-form-input 
                id="adicionalNumero"
                class="number-input"
                v-model.number="adicionalNumero" 
                type="number"
                :state="presupuestoInternoValido"
                @focus="$event.target.select()"/>

              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="getPresupuestoInterno">
                <b-input-group-text>
                  <i class="fa fa-search"></i>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <b-form-group
          label="Cliente:"
          label-for="cliente"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="cliente"
            :value="cliente" 
            readonly
            type="text"/>
        </b-form-group>

        <b-form-group
          label="Acción:"
          label-for="accion"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="accion"
            :value="accion" 
            readonly
            type="text"/>
        </b-form-group>

        <app-orden-trabajo
          label="Orden"
          v-if="seleccionarOrden"
          :nombre="ordenTrabajoNombre"
          :lista="ordenesList"
          :labelCols="labelCols"
          labelOption="Seleccione una orden"
          @updated="ordenActualizada">
        </app-orden-trabajo>  

        <b-form-group
          label="Descripción"
          label-for="ordenTrabajoObservaciones"
          :label-cols="labelCols"
          v-if="seleccionarOrden & !seleccionarSubtrabajo"
          horizontal>
          <b-form-textarea
            id="ordenTrabajoObservaciones"
            :value="ordenTrabajoObservaciones" 
            rows="3"
            max-rows="5"
            readonly>
          </b-form-textarea>
        </b-form-group>

        <app-orden-subtrabajo
          label="Subtrabajo"
          v-if="seleccionarSubtrabajo"
          :nombre="ordenSubtrabajoNombre"
          :lista="ordenesSubtrabajosList"
          :labelCols="labelCols"
          :description="descripcionSubtrabajo"
          @updated="ordenSubtrabajoActualizada">
          <div
              v-if="opcionAgregarSubtrabajo" 
              class="custom-select-add"
              @click.prevent="addOrdenSubtrabajo">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </div>
        </app-orden-subtrabajo>

        <b-form-group
          label="Descripción"
          label-for="ordenSubtrabajoObservaciones"
          :label-cols="labelCols"
          v-if="seleccionarSubtrabajo"
          horizontal>
          <b-form-textarea
            id="ordenSubtrabajoObservaciones"
            :value="ordenSubtrabajoObservaciones" 
            rows="3"
            max-rows="5"
            readonly>
          </b-form-textarea>
        </b-form-group>

        <small v-if="presupuestoCerrado" ><span>(*)</span> Presupuesto cerrado </small>   
      </b-form>

      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>             

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          ref="seleccionarButton"
          @click.prevent="seleccionar">Seleccionar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="subtrabajoModal" 
        title="Datos del Subtrabajo"
        modal-class="modalABM modalOrdenSubtrabajo"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-subtrabajo
        :subtrabajoLogistica="logistica"
        @updateSubtrabajo="updateSubtrabajo"
        @closeSubtrabajo="closeSubtrabajo">
      </app-subtrabajo>  
    </b-modal>
  </div>
</template>

<script>
import OrdenTrabajo from '../shared/abmSelect.vue';
import OrdenSubtrabajo from '../shared/abmSelect.vue';
import Subtrabajo from '../ordenestrabajos/Subtrabajo.vue';
import moment from 'moment';

export default {
  name: 'PresupuestosInternos',
  components: {
    appOrdenTrabajo: OrdenTrabajo,
    appOrdenSubtrabajo: OrdenSubtrabajo,
    appSubtrabajo: Subtrabajo,
  },
  props: {
    clienteId: {
      type: Number,
      default: 0
    },
    // soloPI: {
    //   type: Boolean,
    //   default: false
    // },
    seleccionarOrden: {
      type: Boolean,
      default: true
    },
    seleccionarSubtrabajo: {
      type: Boolean,
      default: true
    },
    soloPresupuestosAbiertos: {
      type: Boolean,
      default: false
    },
    logistica: {
      type: Boolean,
      default: true
    },
    opcionAgregarSubtrabajo: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      presupuestoInternoId: 0,
      presupuestoInterno: {},
      
      numero: 0,
      adicionalNumero: 0,

      ordenTrabajo: {},
      ordenesList: [],
      ordenTrabajoNombre: null,
      ordenTrabajoObservaciones: '',

      ordenSubtrabajo: {},
      ordenesSubtrabajosList: [],
      ordenSubtrabajoNombre: null,
      ordenSubtrabajoObservaciones: '',

      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
      
      presupuestoInternoValido: null,
      
      labelCols: 3
    }
  },
  computed: {
    'cliente': function() {
      let cliente = '';
      if (this.presupuestoInterno) {
        cliente = this.presupuestoInterno.cliente? this.presupuestoInterno.cliente.trim() : '';
      }
      return cliente;
    },
    'accion': function() {
      let accion = '';
      if (this.presupuestoInterno) {
        accion = this.presupuestoInterno.accion? this.presupuestoInterno.accion.trim() : '';
      }
      return accion;
    },
    presupuestoCerrado() {
      if (this.presupuestoInterno) {
        if (this.presupuestoInterno.fechaCierre) {
          return moment(this.presupuestoInterno.fechaCierre).format('YYYY-MM-DD') != '1900-01-01';
        }
      }
      return false;
    },
    descripcionSubtrabajo() {
      if ((/true/i).test(this.logistica)) {
        return 'Sólo subtrabajos de Logística';
      }

      return null;
    }
  },
  created() {
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getPresupuestoInterno() {
      this.presupuestoInternoId = 0;
      this.presupuestoInterno = null;
      this.ordenesList = [];
      this.ordenTrabajoNombre = null;
      this.ordenTrabajoObservaciones = '';
      this.ordenesSubtrabajosList = [];
      this.ordenSubtrabajoNombre = null;
      this.ordenSubtrabajoObservaciones = '';

      let numero = 0;
      if (this.numero) {
        if (!isNaN(this.numero)) {
          numero = parseInt(this.numero);
        }
      }
      let adicionalNumero = -1;
      if (this.adicionalNumero) {
        if (!isNaN(this.adicionalNumero)) {
          adicionalNumero = parseInt(this.adicionalNumero);
        }
      }

      if (numero != 0) {
        let params = {
          clienteId: this.clienteId,
          numero,
          adicionalNumero,
          loadOrdenes: true,
          logistica: this.logistica
        }

        this.showSpinner();
        this.$store.dispatch('presupuestointerno/searchPresupuesto', params)
          .then(() => {
            this.presupuestoInterno = this.$store.getters['presupuestointerno/presupuestoSearch'];
            this.presupuestoInternoId = this.presupuestoInterno.id;
            this.ordenesList = this.$store.getters['presupuestointerno/ordenesListSearch'];
          })
          .catch(error => this.showAlert(error, 'danger'))
          .finally(() => this.hideSpinner())
      } else {
        this.showAlert('Verifique el número de presupuesto ingresado', 'danger');
      }
    },
    seleccionar() {
      if (this.presupuestoInternoId != 0) {
        /* Validamos que seleccione PI + OT + OTA */
        let seleccionar = true;

        if ((/true/i).test(this.seleccionarOrden)) {
          let ordenTrabajoError = true;
          if (this.ordenTrabajo) {
            if (this.ordenTrabajo.id != 0) {
              ordenTrabajoError = false;
            }
          }
          if (ordenTrabajoError) {
            seleccionar = false;

            this.showAlert('Debe seleccionar una orden de trabajo.', 'danger');
          }
        }

        if ((/true/i).test(this.seleccionarSubtrabajo)) {
          if (seleccionar) {
            let subtrabajoError = true;
            if (this.ordenSubtrabajo) {
              if (this.ordenSubtrabajo.id != 0) {
                subtrabajoError = false;
              }
            }
            if (subtrabajoError) {
              seleccionar = false;

              this.showAlert('Debe seleccionar un subtrabajo.', 'danger');
            }
          }
        }

        if ((/true/i).test(this.soloPresupuestosAbiertos)) {
          if(this.presupuestoInterno.fechaCierre) {
            if (moment(this.presupuestoInterno.fechaCierre).format('YYYY-MM-DD') != '1900-01-01') {
                seleccionar = false;
  
                this.showAlert('El presupuesto interno seleccionado se encuentra cerrado.', 'danger');
            }
          }
        }

        if (seleccionar) {
          let params = {
            presupuestoInterno: this.presupuestoInterno,
            ordenTrabajo: this.ordenTrabajo,
            ordenSubtrabajo: this.ordenSubtrabajo
          }
          this.$emit('presupuestoInternoSeleccionado', params);
        }
      } else {
        this.showAlert('No hay ningún presupuesto seleccionado.', 'danger');
      }
    },
    cancelar () {
      this.$emit('cancelaSeleccionPresupuestoInterno');
    },
    ordenActualizada(ordenNombre) {
      this.ordenTrabajo = null;
      this.ordenTrabajoObservaciones = '';
      this.ordenSubtrabajo = null;
      this.ordenesSubtrabajosList = [];
      this.ordenSubtrabajoNombre = null;
      this.ordenSubtrabajoObservaciones = '';
      if (ordenNombre) {
        this.presupuestoInterno.ordenesTrabajos.forEach(ordenTrabajo => {
          if (ordenTrabajo.id.toString().trim() + ' - ' + ordenTrabajo.titulo.trim() == ordenNombre.trim()) {
            this.ordenTrabajo = ordenTrabajo;
            this.ordenTrabajoObservaciones = ordenTrabajo? ordenTrabajo.descripcion : '';
            this.ordenesSubtrabajosList = this.ordenTrabajo.subtrabajosList;
            return;
          }
        });
      }
    },
    ordenSubtrabajoActualizada(ordenSubtrabajoNombre) {
      this.ordenSubtrabajo = null;
      this.ordenSubtrabajoNombre = ordenSubtrabajoNombre;
      if (ordenSubtrabajoNombre) {
        this.ordenTrabajo.subtrabajos.forEach(subtrabajo => {
          if (subtrabajo.id.toString().trim() + ' - ' + subtrabajo.articuloTipo.trim() == ordenSubtrabajoNombre.trim()) {
            this.ordenSubtrabajo = subtrabajo;
            this.ordenSubtrabajoObservaciones = subtrabajo.observaciones.trim();
            return;
          }
        });
      }
    },
    addOrdenSubtrabajo() {
      let addOrdenSubtrabajo = false;
      if (this.ordenTrabajo) {
        if (this.ordenTrabajo.id != 0) {
          addOrdenSubtrabajo = true;
        }
      }

      if (addOrdenSubtrabajo) {
        let params = {
          ordenTrabajoId: this.ordenTrabajo.id,
          logistica: this.logistica
        }
        this.$store.dispatch('ordenSubtrabajo/inicializar', params)
          .then(() => this.$refs.subtrabajoModal.show());

      } else {
        this.showAlert('Seleccione en primer término el presupuesto y la orden correspondiente', 'danger');
      }      
    },
    updateSubtrabajo() {
      this.$refs.subtrabajoModal.hide();

      /* Agregamos el subtrabajo a la lista de la orden */
      let ordenSubtrabajoLogistica = this.$store.getters['ordenSubtrabajo/ordenSubtrabajoLogistica'];

      let params = {
        ordenTrabajoId: this.ordenTrabajo.id,
        ordenSubtrabajo: ordenSubtrabajoLogistica
      }

      this.$store.dispatch('presupuestointerno/addSubtrabajoSearch', params)
        .then(() => {
          this.ordenesSubtrabajosList = this.ordenTrabajo.subtrabajosList;
          // this.ordenesList = this.$store.getters['presupuestointerno/ordenesListSearch']
        });
    },
    closeSubtrabajo() {
      this.$refs.subtrabajoModal.hide();
    },
  },
}
</script>

<style>
</style>
